(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-care-multicolumn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-care-multicolumn')) {
    customElements.define(
      'customer-care-multicolumn',
      class CustomerCareMulticolumn extends HTMLElement {
        constructor() {
          super()
          this.modalLinks = this.querySelectorAll('[data-open-as-modal]')
          this.modalBackdrop = this.querySelector('[data-modal-backdrop]')
          this.closeModalLinks = this.querySelectorAll('[data-close-modal]')
          this.learnMoreLinks = this.querySelectorAll('[data-learn-more]')
          this.dragBarLinks = this.querySelectorAll('[data-drag-bar]')
          this.modalContainer = this.querySelectorAll('.customer-care-multicolumn__modal-container')
          this.body = document.querySelector('body')
          this.init()
        }
        init() {
          // all the toggle code
          this.modalBackdrop.addEventListener('click', this.closeModal.bind(this))
          this.modalLinks.forEach((link) => {
            link.addEventListener('click', this.openModal.bind(this))
          })
          this.closeModalLinks.forEach((link) => {
            link.addEventListener('click', this.closeModal.bind(this))
          })
          this.learnMoreLinks.forEach((link) => {
            link.addEventListener('click', this.openModalDouble.bind(this))
          })

          // this is the swiping code to open and close the modal on swipe up or down.
          this.dragBarLinks.forEach((dragBar) => {
            let context = this
            let touchstartY = 0
            let touchendY = 0
            function checkDirection() {
              // if swiped up
              if (touchendY < touchstartY) {
                if (window.innerWidth <= 768) {
                  context.openModalDouble()
                }
              }
              // if swiped down
              if (touchendY > touchstartY) {
                if (window.innerWidth <= 768) {
                  context.closeModal()
                }
              }
            }
            dragBar.addEventListener('touchstart', function (e) {
              touchstartY = e.changedTouches[0].screenY
            })
            dragBar.addEventListener('touchend', function (e) {
              touchendY = e.changedTouches[0].screenY
              checkDirection()
            })
          })
          // end swiping code
        }

        openModal(e) {
          e.preventDefault()
          let body = document.querySelector('body')
          let blockId = e.currentTarget.getAttribute('data-block-id')
          let modalToOpen = this.querySelector(`.customer-care-multicolumn__modal-container[data-block-id="${blockId}"]`)
          modalToOpen.classList.add('active')
          window.innerWidth <= 768 ? (modalToOpen.style.height = '300px') : null
          this.modalBackdrop.classList.add('active')
          this.body.classList.add('overflow-hidden')
          // always remove overflow-hidden on desktop
          window.innerWidth > 768 ? modalToOpen.classList.remove('overflow-hidden') : null
        }

        openModalDouble(e) {
          const modalToOpen = this.querySelector(`.customer-care-multicolumn__modal-container.active`)
          const headerHeight = document.querySelector('header').offsetHeight

          modalToOpen.classList.add('double-active')
          modalToOpen.style.height = `${window.innerHeight - headerHeight}px`
          // small timeout to prevent drag from scrolling when opening the modal
          setTimeout(function () {
            modalToOpen.classList.remove('overflow-hidden')
          }, 500)
        }

        closeModal(e) {
          let modalToClose = this.querySelector(`.customer-care-multicolumn__modal-container.active`)
          modalToClose.classList.contains('active') ? modalToClose.classList.remove('active') : null
          if (modalToClose.classList.contains('double-active')) {
            modalToClose.classList.remove('double-active')
            modalToClose.style.height = '0px'
          }
          !modalToClose.classList.contains('overflow-hidden') ? modalToClose.classList.add('overflow-hidden') : null
          this.modalBackdrop.classList.contains('active') ? this.modalBackdrop.classList.remove('active') : null
          let context = this
          setTimeout(function () {
            context.body.classList.remove('overflow-hidden')
          }, 500)
        }
      }
    )
  }

  if (!customElements.get('icon-modal-opener')) {
    customElements.define(
      'icon-modal-opener',
      class IconModalOpener extends HTMLElement {
        constructor() {
          super()
          this.button = this.querySelector('button')
          this.init()
        }
        init() {
          this.button.addEventListener('click', this.toggleIconGlossary.bind(this))
        }
        toggleIconGlossary(e) {
          let iconGlossaryLink = document.querySelector('[data-heading="icon-glossary"]')
          if (iconGlossaryLink) {
            iconGlossaryLink.click()
          }
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();
})();
